export { default as Transport } from './containers/TransportContainer'



// WEBPACK FOOTER //
// ./src/TransportGoods/index.js